// extracted by mini-css-extract-plugin
export var backgroundImage = "HomepageSolutions-module--background-image--edab3";
export var content = "HomepageSolutions-module--content--21b4a";
export var gridShowcase = "HomepageSolutions-module--gridShowcase--1a387";
export var mainShowcase = "HomepageSolutions-module--main-showcase--2d8f4";
export var solutions = "HomepageSolutions-module--solutions--ec049";